import GlobalConfig from './dev.env'

// import GlobalConfig from './prod.env'
export default GlobalConfig